import Swiper, { Navigation, Pagination, FreeMode, Thumbs } from "swiper";

const swiper = new Swiper("#thumbnail-slider", {
  modules: [FreeMode],
  spaceBetween: 8,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
});

export const swiper2 = new Swiper("#main-slider", {
  modules: [Navigation, Thumbs],
  thumbs: {
    swiper: swiper,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

export const swiper3 = new Swiper("#main-slider", {
  modules: [Navigation, Thumbs],
  thumbs: {
    swiper: swiper,
  },
  navigation: {
    nextEl: ".swiper-button-nexts",
    prevEl: ".swiper-button-prevs",
  },
});

export const swiperResponsive = new Swiper("#main-slider-pagination", {
  modules: [Navigation, Pagination],
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
